export const SET_GLOBAL_FILTER = "SET_GLOBAL_FILTER";

export const setGlobalFilter = (globalFilter) => {
  return (dispatch) => {
    dispatch({
      type: SET_GLOBAL_FILTER,
      payload: globalFilter,
    });
  };
};
